import { RecordsTable } from 'dyl-components';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from './Header';
import Row from './Row';

const Table = ({ onFilter, onPageChange, onOpenEditDylNumberModal, dylNumbersCount, isReadingDylNumbers, dylNumbers, isPhoneTab, onNewNumber }) => {
    const [params] = useSearchParams();
    return <RecordsTable
        tableBodyClassName='NumbersTable'
        isTableLoading={isReadingDylNumbers}
        isSearchResultEmpty={!dylNumbersCount && (params.get('search') || params.get('type') || params.get('destination_type'))}
        isTableEmpty={!dylNumbersCount && !(params.get('search') || params.get('type') || params.get('destination_type'))}
        tableEmptyMessage='No Numbers Added'
        TableHeader={<Header onFilter={onFilter} count={dylNumbersCount} numbers={dylNumbers?.map((number, idx) => ({ id: number.id || `${number.type}-${idx}` }))} isPhoneTab={isPhoneTab}/>}
        TableRows={dylNumbers?.map?.((number) => <Row number={number} onOpenEditDylNumberModal={onOpenEditDylNumberModal} isPhoneTab={isPhoneTab} onNewNumber={onNewNumber} />)}
        recordsCount={dylNumbersCount}
        activePage={params.get('page')}
        onPageChange={onPageChange}
        recordsName='Number'
        hasPagination={!isPhoneTab}
    />
}

export default Table;
